import React, { useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";

import moment from "moment";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";

import AccountList from "./AccountList.js";

const View = ({ id }) => {
    const [serviceAppList, setServiceAppList] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!serviceAppList) {
            commonData.getServiceAppList(axios, (err, list) => {
                if (!err) {
                    setServiceAppList(list);
                }
            });
        }
        return () => {};
    }, [id]);

    useEffect(() => {
        if (serviceAppList) getInfo();
        return () => {};
    }, [serviceAppList]);

    const getInfo = () => {
        setData(null);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/branch/${id}`,
        })
            .then((res) => {
                const _data = {
                    branch: res.data.branch,
                    bizApp: res.data.bizApp,
                    account: res.data.account,
                };
                const attach = {};
                res.data.attach.forEach((a) => {
                    attach[a.type] = a;
                });
                _data.attach = attach;
                _data.branch.ceo_num = _data.branch.ceo_num ? Buffer.from(_data.branch.ceo_num, "base64").toString("utf8") : "";
                _data.branch.ceo_num = _data.branch.ceo_num.replace(/(\d\d\d\d\d\d)(\d)(\d\d\d\d\d\d)/g, "$1-$2******");

                let result = [];
                if (_data.bizApp && _data.bizApp.length > 0) {
                    _data.bizApp.forEach((a) => {
                        if (serviceAppList.find(app => a == app.appId)) {
                            result.push(serviceAppList.find(app => a == app.appId));
                        }
                    });
                }
                _data.bizApp = result;
                setData(_data);
            })
            .catch((error) => {
                console.log(error);
                setData(null);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    if (!data) {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">
                                        <span className="fa fa-spinner" />
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">{data.branch.name}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid dashboard-content pb-2">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="page-header mb-2">
                                <h5 className="pageheader-title text-muted">지사 정보</h5>
                            </div>
                            <table className="table table-bordered bg-light">
                                <colgroup>
                                    <col style={{ minWidth: "150px", width: "20%" }} />
                                    <col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th className="bg-dark text-light">지사 코드(ID)</th>
                                        <td>
                                            <span className="mt-2 text-danger">{data.branch.code}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사명</th>
                                        <td>
                                            <span className="mt-2 text-danger">{data.branch.name}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사장 명</th>
                                        <td>
                                            <span className="mt-2">{data.branch.rep}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사장 휴대전화</th>
                                        <td>
                                            <span className="mt-2">{data.branch.mobile}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사 유선전화</th>
                                        <td>
                                            <span className="mt-2">{data.branch.tel}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사 팩스</th>
                                        <td>
                                            <span className="mt-2">{data.branch.fax}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사 이메일</th>
                                        <td>
                                            <span className="mt-2">{data.branch.email}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">지사 주소</th>
                                        <td>
                                            <span className="mt-2">{data.branch.address}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">계약 권한</th>
                                        <td>
                                            <span className="mt-2 text-primary">{data.bizApp.map(a => a.name).join(", ")}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colSpan="2" className="bg-dark text-light">
                                            정산 담당자 정보
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">담당자 명</th>
                                        <td>
                                            <span className="mt-2">{data.branch.cal_charger}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">담당자 휴대전화</th>
                                        <td>
                                            <span className="mt-2">{data.branch.cal_charger_mobile}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">담당자 이메일</th>
                                        <td>
                                            <span className="mt-2">{data.branch.cal_charger_email}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="page-header mb-2">
                                <h5 className="pageheader-title text-muted">지사 사업자 정보</h5>
                            </div>
                            <table className="table table-bordered bg-light">
                                <colgroup>
                                    <col style={{ minWidth: "150px", width: "20%" }} />
                                    <col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th colSpan="2" className="bg-dark text-light">
                                            사업자 정보
                                        </th>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자등록 상호</th>
                                        <td>
                                            <strong className="mt-2">{data.branch.cntnts_name}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자등록 번호</th>
                                        <td>
                                            <span className="mt-2">{data.branch.cntnts_num}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자 대표멍</th>
                                        <td>
                                            <span className="mt-2">{data.branch.ceo}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자 대표 주민번호</th>
                                        <td>
                                            <span className="mt-2">{data.branch.ceo_num}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자 대표 휴대전화</th>
                                        <td>
                                            <span className="mt-2">{data.branch.ceo_tel}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">거래처 업태</th>
                                        <td>
                                            <span className="mt-2">{data.branch.cntnts_type}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">거래처 종목</th>
                                        <td>
                                            <span className="mt-2">{data.branch.cntnts_type}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업장 주소</th>
                                        <td>
                                            <span className="mt-2">{data.branch.address}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자 대표 거주 주소</th>
                                        <td>
                                            <span className="mt-2">{data.branch.ceo_address}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자 통장 정보</th>
                                        <td>
                                            <span className="mt-2">
                                                {data.branch.bank} {data.branch.bank_account}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자등록증</th>
                                        <td>
                                            {data.attach.C && (
                                                <>
                                                    <span className="mt-2">{data.attach.C.file_name}</span>
                                                    <ImageModal type="C" file_name={data.attach.C.file_name} file_data={data.attach.C.file_data} />
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">대표 주민등록증</th>
                                        <td>
                                            {data.attach.J && (
                                                <>
                                                    <span className="mt-2">{data.attach.J.file_name}</span>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="bg-dark text-light">사업자 통장사본</th>
                                        <td>
                                            {data.attach.B && (
                                                <>
                                                    <span className="mt-2">{data.attach.B.file_name}</span>
                                                    <ImageModal type="B" file_name={data.attach.B.file_name} file_data={data.attach.B.file_data} />
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <AccountList id={id} account={data.account} branch={data ? data.branch : null} reloadAccount={getInfo} />
                </div>
            </div>
        </div>
    );
};

const ImageModal = ({ type, file_name, file_data }) => {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState("");

    useEffect(() => {
        let title = "사업자등록증";
        switch (type) {
            case "C":
                title = "사업자등록증";
                break;
            case "J":
                title = "대표 주민등록증";
                break;
            case "B":
                title = "사업자 통장사본";
                break;
        }
        setTitle(title);
        return () => {};
    }, [type, file_name, file_data]);

    return (
        <>
            <button className="float-right btn btn-sm btn-success ml-3 font-12 btn-rounded" onClick={() => setShow(true)}>
                보기
            </button>
            <Modal show={show} onHide={() => setShow(false)} aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ overflow: "auto" }}>{file_data && <img src={Buffer.from(file_data, "base64").toString("utf8")} alt={file_name} style={{ width: "100%" }} />}</Modal.Body>
            </Modal>
        </>
    );
};

export default View;
